export default __webpack_public_path__ + "assets/9938f0bb4045bb1ef6a9f5abf4d2b8a0.png";